// extracted by mini-css-extract-plugin
module.exports = {"jobCountContainer":"FirmDashboardJobsViewer__jobCountContainer___zuH7k","resultCount":"FirmDashboardJobsViewer__resultCount___XoYRn"};